"use client"

import { Trans } from "@lingui/react/macro"
import { cn } from "@rarible_int/anaconda_ui_components"

export function LegalNav({ className }: { className?: string }) {
  return (
    <ul
      className={cn("flex items-center gap-2", className)}
      data-testid="legal-nav"
    >
      <li>
        <span className="text-foreground/60">&copy; Gahinga Inc.</span>
      </li>
      <li>
        <a
          className="text-foreground/60"
          href="/terms"
          target="_blank"
          rel="noreferrer"
        >
          <Trans>Terms</Trans>
        </a>
      </li>
      <li>
        <a
          className="text-foreground/60"
          href="/privacy"
          target="_blank"
          rel="noreferrer"
        >
          <Trans>Privacy</Trans>
        </a>
      </li>
      <li>
        <a
          className="text-foreground/60"
          href="/faq"
          target="_blank"
          rel="noreferrer"
        >
          <Trans>FAQ</Trans>
        </a>
      </li>
      <li>
        <a
          className="text-foreground/60"
          href="http://rarible.org/"
          target="_blank"
          rel="noreferrer"
        >
          <Trans>API</Trans>
        </a>
      </li>
    </ul>
  )
}
